/**
 * QUANTICA · <q-qty>
 *
 * Selector de cantidad. Envuelve un <input type="number"> real, asi que
 * sin JS sigue siendo usable con el teclado y con los controles nativos
 * del navegador; el JS solo agrega los botones de mas y menos.
 *
 * El HTML aprobado usaba un <span> con el numero y leia textContent, que
 * no es un campo de formulario: no se puede tipear, no se envia en un
 * form y el lector de pantalla no lo anuncia como control.
 */
class QQty extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    if (!this.input) return;

    this.querySelector('[data-qty-minus]')?.addEventListener('click', () => this.step(-1));
    this.querySelector('[data-qty-plus]')?.addEventListener('click', () => this.step(1));
    this.input.addEventListener('change', () => this.clamp());
    this.clamp();
  }

  get min() { return Number(this.input.min) || 1; }
  get max() { return Number(this.input.max) || 99; }

  step(d) {
    this.input.value = String(this.clampValue(Number(this.input.value) + d));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  clampValue(n) {
    if (!Number.isFinite(n)) return this.min;
    return Math.min(this.max, Math.max(this.min, Math.round(n)));
  }

  clamp() {
    this.input.value = String(this.clampValue(Number(this.input.value)));
    const v = Number(this.input.value);
    const minus = this.querySelector('[data-qty-minus]');
    const plus = this.querySelector('[data-qty-plus]');
    if (minus) minus.disabled = v <= this.min;
    if (plus) plus.disabled = v >= this.max;
  }
}

if (!customElements.get('q-qty')) {
  customElements.define('q-qty', QQty);
}
